/*
 * 使用环境
 */
let _u = navigator.userAgent.toLowerCase();
let _app = navigator.appVersion;

// 内核
let _getCore = function () {
  return {
    trident: _u.indexOf('trident') > -1, //IE内核
    webKit: _u.indexOf('applewebKit') > -1, //苹果、谷歌内核
    mobile: !!_u.match(/applewebKit.*mobile.*/), // 是否为移动终端
    android: _u.indexOf('android') > -1 || _u.indexOf('adr') > -1, //android终端
    iPad: _u.indexOf('ipad') > -1, // 是否iPad
    weixin: _u.indexOf('micromessenger') > -1 // 是否微信 （2015-01-22新增）
  };
};

// 是否为ios
let _isIos = function () {
  return /(iphone|ipad|ipod|ios)/i.test(_u);
};

// 是否为安卓
let _isAndriod = function () {
  return /(android)/i.test(_u);
};

// 是否为chrome
let _isChrome = function () {
  return _u.indexOf('crios') !== -1 || _u.indexOf('chrome') !== -1;
};

// 是否为qq浏览器
let _isQQ = function () {
  return _u.indexOf('mqqbrowser') !== -1 || _u.indexOf('qbwebviewtype') !== -1 || _u.indexOf('micromessenger') !== -1;
};

// 是否为uc浏览器
let _isUC = function () {
  return _u.indexOf('ucbrowser') !== -1;
};

// 是凑是miui浏览器
let _isMiuiBrower = function () {
  return _u.indexOf('xiaomi/miuibrowser') !== -1;
}

let _isSafari = function () {
  return _u.indexOf('safari') !== -1 && _u.indexOf('crios') === -1 && _u.indexOf('chrome') === -1 &&
    _u.indexOf('mqqbrowser') === -1 && _u.indexOf('ucbrowser') === -1 && _u.indexOf('baidubrowser') === -1;
};

let _isBaidu = function () {
  return _u.indexOf('baidubrowser') !== -1;
};

let _isBaiduApp = function () {
  return _u.indexOf('baiduboxapp') !== -1;
}

let _isVivo = function () {
  return _u.indexOf('vivo x6s') !== -1 || _u.indexOf('v1911a') !== -1 || _u.indexOf('vivobrowser') !== -1;
};

let _isHuaweiBrower = function () {
  return _u.indexOf('huaweibrowser') !== -1;
};

let browerCore = _getCore() || {};

let ios_version;
let android_version;
(function () {
  if (_isIos()) {
    let ver = _u.match(/cpu iphone os (.*?) like mac os/);
    ver = (ver && ver[1]) ? ver[1].replace(/_/g, ".") : null;
    ios_version = ver;
  }
  if (_isAndriod()) {
    let ver = _u.match(/linux; android (.*?);/);
    ver = (ver && ver[1]) ? ver[1].replace(/_/g, ".") : null;
    android_version = ver;
  }
})();

export default {
  isIos: _isIos(),
  isAndriod: _isAndriod(),
  isSafari: _isSafari(),
  isUC: _isUC(),
  isQQ: _isQQ(),
  isBaidu: _isBaidu(),
  isBaiduApp: _isBaiduApp(),
  isVivo: _isVivo(),
  isChrome: _isChrome(),
  isMiuiBrower: _isMiuiBrower(),
  isHuaweiBrower: _isHuaweiBrower(),
  isWeixin: browerCore.weixin,
  ios_version: ios_version,
  android_version: android_version
};

